export default __webpack_public_path__ + "static/media/love_this_bubble.1f8f6758.svg";